import React from "react";

export default function LeftComponent({ children }) {
  return (
    <div className="laptop:w-[50%] mobile:w-[100%] laptop:p-2 shadow-xl border border-slate-950 bg-white text-black flex flex-col mobile:pb-2 rounded-l-lg">
      {children}
    </div>
  );
}
